import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '@/store/index';

Vue.use(VueRouter);

const LOGIN_TYPE = (to, from, next) => {
  if (store.getters.isUser) {
    next({ name: 'report' });
  } else {
    next({ name: 'booking' });
  }
};

const router = new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/',
      beforeEnter: LOGIN_TYPE,
    },
    {
      path: '/booking',
      name: 'booking',
      component: () => import('@/views/booking/index.vue'),
      meta: {
        auth: true,
        breadcrumb: [{ name: '부킹현황' }],
      },
    },
    {
      path: '/booking/:id/days/:day',
      name: 'bookingMedia',
      component: () => import('@/views/booking/view.vue'),
      props: true,
      meta: {
        auth: true,
        breadcrumb: [{ name: '부킹현황' }],
      },
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/LoginPage.vue'),
      meta: {
        auth: false,
      },
    },
    {
      path: '/campaign',
      name: 'campaign',
      component: () => import('@/views/campaign/index.vue'),
      meta: {
        auth: true,
        breadcrumb: [{ name: '캠페인 관리' }],
      },
    },
    {
      path: '/campaign/register',
      name: 'campaignRegister',
      component: () => import('@/views/campaign/register.vue'),
      meta: {
        auth: true,
        breadcrumb: [
          { name: '캠페인 관리', href: 'campaign' },
          { name: '캠페인 등록' },
        ],
      },
    },
    {
      path: '/campaign/:id/inventories_list',
      name: 'campaignInventoriesList',
      component: () => import('@/views/campaign/listInventoies.vue'),
      meta: {
        auth: true,
        breadcrumb: [
          { name: '캠페인 관리', href: 'campaign' },
          { name: '캠페인 등록' },
        ],
      },
    },
    {
      path: '/campaign/:id/modify',
      name: 'campaignModify',
      component: () => import('@/views/campaign/modify.vue'),
      meta: {
        auth: true,
        breadcrumb: [
          { name: '캠페인 관리', href: 'campaign' },
          { name: '캠페인 수정' },
        ],
      },
    },
    {
      path: '/campaign/:id/modify/inventories_list',
      name: 'campaignInventoriesListModify',
      component: () => import('@/views/campaign/modifyListInventoies.vue'),
      meta: {
        auth: true,
        breadcrumb: [
          { name: '캠페인 관리', href: 'campaign' },
          { name: '캠페인 수정' },
        ],
      },
    },
    {
      path: '/campaign/:id/inventories_add',
      name: 'campaignInventoriesAdd',
      component: () => import('@/views/campaign/addInventory.vue'),
      meta: {
        auth: true,
        breadcrumb: [
          { name: '캠페인 관리', href: 'campaign' },
          { name: '캠페인 상품(지면) 추가' },
        ],
      },
    },
    {
      path: '/partners',
      name: 'partners',
      component: () => import('@/views/partners/index.vue'),
      meta: {
        auth: true,
        breadcrumb: [{ name: '광고주 관리', href: 'partners' }],
      },
    },
    {
      path: '/partners/modify/:id',
      name: 'partnersDetail',
      component: () => import('@/views/partners/modify.vue'),
      meta: {
        auth: true,
        breadcrumb: [
          { name: '광고주 관리', href: 'partners' },
          { name: '광고주 수정' },
        ],
      },
    },
    {
      path: '/partners/register',
      name: 'partnerRegister',
      component: () => import('@/views/partners/register.vue'),
      meta: {
        auth: true,
        breadcrumb: [
          { name: '광고주 관리', href: 'partners' },
          { name: '광고주 등록' },
        ],
      },
    },
    {
      path: '/media',
      name: 'media',
      component: () => import('@/views/media/index.vue'),
      meta: {
        auth: true,
        breadcrumb: [{ name: '매체 관리', href: 'media' }],
      },
    },
    {
      path: '/media/modify/:id',
      name: 'mediaModify',
      component: () => import('@/views/media/modify.vue'),
      meta: {
        auth: true,
        breadcrumb: [
          { name: '매체 관리', href: 'media' },
          { name: '매체 수정' },
        ],
      },
    },
    {
      path: '/media/register',
      name: 'mediaRegister',
      component: () => import('@/views/media/register.vue'),
      meta: {
        auth: true,
        breadcrumb: [
          { name: '매체 관리', href: 'media' },
          { name: '매체 등록' },
        ],
      },
    },
    {
      path: '/media/:id/inventoriesWrite',
      name: 'mediaInventoriesWrite',
      component: () => import('@/views/media/inventoriesWrite.vue'),
      meta: {
        auth: true,
        breadcrumb: [
          { name: '매체 관리', href: 'media' },
          { name: '매체 등록' },
        ],
      },
    },
    {
      path: '/media/:id/inventories',
      name: 'mediaInventories',
      component: () => import('@/views/media/inventories.vue'),
      meta: {
        auth: true,
        breadcrumb: [
          { name: '매체 관리', href: 'media' },
          { name: '매체 수정' },
        ],
      },
    },
    {
      path: '/media/course',
      name: 'mediaCourse',
      component: () => import('@/views/media/course.vue'),
      meta: {
        auth: true,
        breadcrumb: [
          { name: '매체 관리', href: 'media' },
          { name: '코스 관리' },
        ],
      },
    },
    {
      path: '/media/xml',
      name: 'mediaXml',
      component: () => import('@/views/media/xmlManage.vue'),
      meta: {
        auth: true,
        breadcrumb: [
          { name: '매체 관리', href: 'media' },
          { name: '3D배너_XML 관리' },
        ],
      },
    },
    {
      path: '/report',
      name: 'report',
      component: () => import('@/views/report/index.vue'),
      meta: {
        auth: true,
        breadcrumb: [{ name: '리포트', href: 'report' }],
      },
    },
    {
      path: '/report/:id',
      name: 'reportCampaign',
      component: () => import('@/views/report/viewCampaign.vue'),
      props: true,
      meta: {
        auth: true,
        breadcrumb: [{ name: '리포트', href: 'report' }],
      },
    },
    {
      path: '/report/:id/medias/:mediaId',
      name: 'reportMedias',
      component: () => import('@/views/report/viewMedias.vue'),
      props: true,
      meta: {
        auth: true,
        breadcrumb: [{ name: '리포트', href: 'report' }],
      },
    },
    {
      path: '/reportvx',
      name: 'reportvx',
      component: () => import('@/views/reportvx/index.vue'),
      meta: {
        auth: true,
        breadcrumb: [{ name: '리포트', href: 'reportvx' }],
      },
    },
    {
      path: '/reportvx/:id',
      name: 'reportvxCampaign',
      component: () => import('@/views/reportvx/viewCampaign.vue'),
      props: true,
      meta: {
        auth: true,
        breadcrumb: [{ name: '리포트', href: 'reportvx' }],
      },
    },
    {
      path: '/reportvx/:id/medias/:mediaId',
      name: 'reportvxMedias',
      component: () => import('@/views/reportvx/viewMedias.vue'),
      props: true,
      meta: {
        auth: true,
        breadcrumb: [{ name: '리포트', href: 'reportvx' }],
      },
    },
    {
      path: '/account',
      name: 'account',
      component: () => import('@/views/account/index.vue'),
      meta: {
        auth: true,
        breadcrumb: [{ name: '계정권한관리', href: 'account' }],
      },
    },
    {
      path: '/account/register',
      name: 'accountRegister',
      component: () => import('@/views/account/register.vue'),
      meta: {
        auth: true,
        breadcrumb: [
          { name: '계정권한관리', href: 'account' },
          { name: '계정등록' },
        ],
      },
    },
    {
      path: '/account/:id',
      name: 'accountUpdate',
      component: () => import('@/views/account/update.vue'),
      meta: {
        auth: true,
        breadcrumb: [
          { name: '계정권한관리', href: 'account' },
          { name: '계정정보수정' },
        ],
      },
    },
    {
      path: '*',
      name: 'error',
      component: () => import('@/views/NotFoundPage.vue'),
      meta: {
        auth: false,
      },
    },
    {
      path: '/notfound',
      name: 'notfound',
      component: () => import('@/views/NotFoundPage.vue'),
      meta: {
        auth: false,
        hasPath: true,
      },
    },
    /*
		{
			path: '/guide',
			component: () => import('~@/Guide.vue'),
			meta: {
				auth: true,
			},
		},
		{
			path: '/server',
			name: 'server',
			component: () => import('@/views/ServerPage.vue'),
			meta: {
				auth: true,
			},
		},
		{
			path: '/fileupload',
			name: 'fileUpload',
			component: () => import('@/components/FileUpload.vue'),
			meta: {
				auth: false,
				hasPath: true,
			},
		},
		{
			path: '/date',
			name: 'date',
			component: () => import('@/components/date.vue'),

			meta: {
				auth: false,
				hasPath: true,
			},
		},
		{
			path: '/test',
			name: 'test',
			component: () => import('@/components/test.vue'),
			meta: {
				auth: false,
				hasPath: true,
			},
		},*/
    {
      path: '/media/v2/modify/:id',
      name: 'mediaModifyV2',
      component: () => import('@/views/media/v2/modify.vue'),
      meta: {
        auth: true,
        breadcrumb: [
          { name: '매체 관리', href: 'media' },
          { name: '매체 수정' },
        ],
      },
    },
    {
      path: '/media/v2/register',
      name: 'mediaRegisterV2',
      component: () => import('@/views/media/v2/register.vue'),
      meta: {
        auth: true,
        breadcrumb: [
          { name: '매체 관리', href: 'media' },
          { name: '매체 등록' },
        ],
      },
    },
    {
      path: '/media/v2/:id/inventoriesWrite',
      name: 'mediaInventoriesWriteV2',
      component: () => import('@/views/media/v2/inventoriesWrite.vue'),
      meta: {
        auth: true,
        breadcrumb: [
          { name: '매체 관리', href: 'media' },
          { name: '매체 등록' },
        ],
      },
    },
    {
      path: '/media/v2/:id/inventories',
      name: 'mediaInventoriesV2',
      component: () => import('@/views/media/v2/inventories.vue'),
      meta: {
        auth: true,
        breadcrumb: [
          { name: '매체 관리', href: 'media' },
          { name: '매체 수정' },
        ],
      },
    },
    {
      path: '/media/v2/course',
      name: 'mediaCourseV2',
      component: () => import('@/views/media/v2/course.vue'),
      meta: {
        auth: true,
        breadcrumb: [
          { name: '매체 관리', href: 'media' },
          { name: '코스 관리' },
        ],
      },
    },
    {
      path: '/media/v2/courseGroup',
      name: 'mediaCourseGroup',
      component: () => import('@/views/media/v2/courseGroup.vue'),
      meta: {
        auth: true,
        breadcrumb: [
          { name: '매체 관리', href: 'media' },
          { name: '그룹 CC 관리' },
        ],
      },
    },
    {
      path: '/media/v2/option',
      name: 'mediaOption',
      component: () => import('@/views/media/v2/option/index.vue'),
      meta: {
        auth: true,
        breadcrumb: [
          { name: '매체 관리', href: 'media' },
          { name: '지면 옵션 관리' },
        ],
      },
    },
    {
      path: '/media/v2/option/register',
      name: 'mediaOptionRegister',
      component: () => import('@/views/media/v2/option/register.vue'),
      meta: {
        auth: true,
        breadcrumb: [
          { name: '매체 관리', href: 'media' },
          { name: '지면 옵션 등록' },
        ],
      },
    },
    {
      path: '/media/v2/option/modify/:optionGroupId',
      name: 'mediaOptionModify',
      component: () => import('@/views/media/v2/option/register.vue'),
      meta: {
        auth: true,
        breadcrumb: [
          { name: '매체 관리', href: 'media' },
          { name: '지면 옵션 수정' },
        ],
      },
    },
  ],
  // scrollBehavior(to, from, savedPosition) {
  // 	return { x: 0, y: 0 };
  // },
});

router.beforeEach((to, from, next) => {
  if (to.meta.auth && !store.getters.isLogin) {
    next('/login');
    return;
  }
  next();
});

export default router;
